// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3y9fK","summary":"CartItem_summary__ESq1b","price":"CartItem_price__b43GT","amount":"CartItem_amount__3QfeA","actions":"CartItem_actions__94hcI"};